import React, { useState } from "react";
import { useEffect } from "react";
import { licenseUpdate } from "../graph";
import { Alert, Table } from "react-bootstrap";
import "../styles/App.css";

export const SelectTableComponent = ({ UserData }) => {
  const subsriptionDetails = UserData;
  const [List, setList] = useState(UserData.userInfo);
  const [MasterChecked, setMasterChecked] = useState();
  const [totalLicensePurchased, setTotalLicensePurchased] = useState(
    UserData.totalLicensePurchased
  );
  const userName = UserData.userName;
  const [availableLicense, setAvailableLicense] = useState(
    UserData.availableLicense
  );

  useEffect(() => {
    let usedLicense = List.filter((e) => e.hasLicense);
    const tempAvailableLicense =
      totalLicensePurchased - usedLicense.length < 0
        ? 0
        : totalLicensePurchased - usedLicense.length;
    setAvailableLicense(tempAvailableLicense);
    if (usedLicense.length == List.length) setMasterChecked(true);
    else setMasterChecked(false);
  }, [List]);

  const showAdminAlert = () => {
    document.getElementById("alertdanger3").style.display = "block";
    setTimeout(() => {
      document.getElementById("alertdanger3").style.display = "none";
    }, 5000);
  };

  const isAdminUser = (user) => user.isAdmin || user.IsAdmin;

  // Select/ UnSelect Table rows
  const onMasterCheck = (e) => {
    if (e.target.checked) {
      if (List.length > totalLicensePurchased) {
        e.stopPropagation();
        document.getElementById("alertdanger2").style.display = "block";
        setTimeout(() => {
          document.getElementById("alertdanger2").style.display = "none";
        }, 5000);
        return;
      } else {
        let tempList = List.map((user) => {
          user.hasLicense = true;
          return user;
        });
        setList(tempList);
      }
    } else {
      const hasAdminUsers = List.some(isAdminUser);
      let tempList = List.map((user) => {
        if (!isAdminUser(user)) {
          user.hasLicense = false;
        }
        return user;
      });
      setList(tempList);
      if (hasAdminUsers) {
        showAdminAlert();
      }
    }
  };

  // Update List Item's state and Master Checkbox State
  const onItemCheck = (e, item) => {
    if (isAdminUser(item)) {
      e.stopPropagation();
      showAdminAlert();
      return;
    }

    if (e.target.checked && availableLicense == 0) {
      document.getElementById("alertdanger2").style.display = "block";
      setTimeout(() => {
        document.getElementById("alertdanger2").style.display = "none";
      }, 5000);
      e.stopPropagation();
      return;
    } else if (
      !e.target.checked &&
      totalLicensePurchased - availableLicense == 1
    ) {
      document.getElementById("alertdanger").style.display = "block";
      setTimeout(() => {
        document.getElementById("alertdanger").style.display = "none";
      }, 5000);
      e.stopPropagation();
      return;
    }

    let tempList = List.map((user) => {
      if (user.UserId === item.UserId) {
        user.hasLicense = e.target.checked;
      }
      return user;
    });
    setList(tempList);
  };

  // Event to get selected rows(Optional)
  const getSelectedRows = () => {
    licenseUpdate(List);
    document.getElementById("alertsuccess").style.display = "block";
    setTimeout(() => {
      document.getElementById("alertsuccess").style.display = "none";
    }, 5000);
  };

  const searchByName = () => {
    var input = document.getElementById("txtName");
    var filter = input.value;

    var trs = document.querySelectorAll("tr");
    var trsToDisplay = [];
    var trsToHide = [];
    trs.forEach((tr, i) => {
      if (tr.innerText.toLowerCase().indexOf(filter.toLowerCase()) > -1)
        trsToDisplay.push(tr);
      else trsToHide.push(tr);
    });
    trsToHide.map((tr) => (tr.style.display = "none"));
    trsToDisplay.map((tr) => (tr.style.display = ""));
  };

  const searchByEmailId = () => {
    var input2, filter2, table, tr, td, i, txtValue;

    input2 = document.getElementById("txtEmailid");
    if (input2 != null) filter2 = input2.value.toUpperCase();
    table = document.getElementById("myTable");
    if (table != null) {
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[1];
        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.toUpperCase().indexOf(filter2) > -1) {
            tr[i].style.display = "";
          }
        }
      }
    }
  };

  return (
    <div style={{ marginLeft: "3%" }}>
      <div>
        <p>
          <strong>
            License count:{" "}
            {totalLicensePurchased
              ? totalLicensePurchased
              : subsriptionDetails?.quantity}{" "}
            &nbsp;&nbsp; Available to assign: {availableLicense}
          </strong>
          <div style={{ float: "right", marginRight: "9%" }}>
          
          <input
            type="text"
            id="txtName"
            
            onKeyUp={(e) => searchByName()}
            placeholder="Search by name or email"
            title="Type in a name"
          ></input>
          <button
          style={{ marginLeft: "10px" }}
            className="btn btn-primary"
            onClick={() => getSelectedRows()}
          >
            Update
          </button>
          </div>
        </p>
      </div>
      <div className="row">
        <div className="col-md-11">
          <div id="mainDiv">
            <Table striped bordered hover id="myTable">
              <thead>
                <tr>
                  <th scope="col" style={{ width: "7%" }}>
                    <input
                      type="checkbox"
                      style={{ marginLeft: "26px" }}
                      checked={MasterChecked}
                      id="mastercheck"
                      onChange={(e) => onMasterCheck(e)}
                    />
                  </th>
                  <th scope="col">Name </th>
                  <th scope="col">Email address </th>
                </tr>
              </thead>
              <tbody>
                {List &&
                  Array.isArray(List) &&
                  List.map((user) => (
                    <tr
                      key={user.UserId}
                      className={user.hasLicense ? "selected" : ""}
                    >
                      <td>
                        <input
                          type="checkbox"
                          style={{ marginLeft: "26px" }}
                          checked={user.hasLicense}
                          id="rowcheck{user.UserId}"
                          onChange={(e) => onItemCheck(e, user)}
                        />
                      </td>
                      <td>{user.UserName}</td>
                      <td>{user.UserEmail}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
          <div id="alertsuccess">
            <Alert variant="success">
              {" "}
              <span>✔</span> User licenses have been successfully updated.
            </Alert>{" "}
          </div>
          <div id="alertdanger">
            <Alert variant="danger">
              {" "}
              Please select at least 1 checkbox to assign your purchased
              license.
            </Alert>{" "}
          </div>
          <div id="alertdanger2">
            <Alert variant="danger">
              {" "}
              You can assign licenses to up to{" "}
              <b>
                {totalLicensePurchased
                  ? totalLicensePurchased
                  : subsriptionDetails?.quantity}
              </b>{" "}
              users. To use Safety Check bot features for more users, please
              purchase additional licenses of Safety Check bot premium.
            </Alert>{" "}
          </div>
          <div id="alertdanger3">
            <Alert variant="danger">
              This user is a Safety Check admin. Assign another team member as an admin or remove this user's admin access before removing their license.
            </Alert>
          </div>
          <button
        style={{ marginTop: "1rem", float:"right"}}
        className="btn btn-primary"
        id="cancelButton"
        onClick={() => {
          if (window.confirm("Are you sure you want to cancel subscription?")) {
            document.getElementById("cancelButton").style.display = "none";
            props.cancelSubscription();
          }
        }}
      >
        <span>Cancel Subscription</span>
      </button>
        </div>
      </div>
    </div>
  );
};

export default SelectTableComponent;
